import EastIcon from "@mui/icons-material/East";
import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.png";
import { MenuItem } from "@mui/material";
import Typography from "@mui/material/Typography";

const pages = [
  { page: "Home", route: "home" },
  { page: "About Us", route: "aboutus" },
  { page: "Services", route: "services" },
];

function AppBarMenu() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    // <AppBar position="static" sx={{ backgroundColor: "#fff" }}>
    //   <Container maxWidth="xl">
    //     <Toolbar disableGutters>
    //       <Box
    //         component={"img"}
    //         src={Logo}
    //         sx={{ width: 50, height: 50, borderRadius: 30 }}
    //       />
    //       <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
    //         <IconButton
    //           size="large"
    //           aria-label="account of current user"
    //           aria-controls="menu-appbar"
    //           aria-haspopup="true"
    //           onClick={handleOpenNavMenu}
    //         >
    //           <MenuIcon />
    //         </IconButton>
    //         <Menu
    //           id="menu-appbar"
    //           anchorEl={anchorElNav}
    //           anchorOrigin={{
    //             vertical: "bottom",
    //             horizontal: "left",
    //           }}
    //           keepMounted
    //           transformOrigin={{
    //             vertical: "top",
    //             horizontal: "left",
    //           }}
    //           open={Boolean(anchorElNav)}
    //           onClose={handleCloseNavMenu}
    //         >
    //           {pages.map((item) => (
    //             <Link
    //               to={item.route}
    //               style={{ textDecoration: "none", color: "#000" }}
    //               key={item.route}
    //             >
    //               <MenuItem key={item.page} onClick={handleCloseNavMenu}>
    //                 <Typography textAlign="center">{item.page}</Typography>
    //               </MenuItem>
    //             </Link>
    //           ))}
    //         </Menu>
    //       </Box>
    //       <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, ml: 3 }}>
    //         {pages.map((item) => (
    //           <Link
    //             to={item.route}
    //             style={{ textDecoration: "none" }}
    //             key={item.route}
    //           >
    //             <Button
    //               key={item.page}
    //               onClick={handleCloseNavMenu}
    //               sx={{
    //                 my: 2,
    //                 color: "#000",
    //                 display: "block",
    //                 fontSize: 12,
    //               }}
    //             >
    //               {item.page}
    //             </Button>
    //           </Link>
    //         ))}
    //       </Box>

    //       <Box sx={{ flexGrow: 0 }}>
    //         <Button
    //           variant="contained"
    //           sx={{
    //             fontWeight: 600,
    //             borderRadius: 30,
    //             display: { xs: "none", md: "flex" },
    //             textTransform: "none",
    //           }}
    //         >
    //           Contact us <EastIcon color="white" sx={{ ml: 1 }} />
    //         </Button>
    //       </Box>
    //     </Toolbar>
    //   </Container>
    // </AppBar>

    <AppBar position="static" sx={{ backgroundColor: "#fff" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box
            component={"img"}
            src={Logo}
            sx={{ width: 50, height: 50, borderRadius: 30 }}
          />
          <Typography
            sx={{
              color: "#000",
              fontSize: "1.5rem",
              px: 10,
              fontWeight: 600,
            }}
          >
            Helpsoo
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default AppBarMenu;
